import base64 from 'base-64';
const LINGUIST_HEADER_KEY = 'x-wix-linguist';
export function linguistHeader({ lang, locale, isPrimaryLanguage, signedInstance, }) {
    // Validate all parameters exists in order to create the linguist header.
    if (isMultilingualOptionsAreValid({ lang, locale, isPrimaryLanguage })) {
        const instanceId = getInstanceIdFromSignedInstance(signedInstance);
        if (instanceId !== undefined) {
            return {
                [LINGUIST_HEADER_KEY]: [
                    lang,
                    locale,
                    isPrimaryLanguage?.toString(),
                    instanceId,
                ].join('|'),
            };
        }
    }
    return {};
}
function isMultilingualOptionsAreValid({ lang, locale, isPrimaryLanguage, }) {
    return (lang && locale && /^(true|false)$/.test(isPrimaryLanguage?.toString() || ''));
}
function getInstanceIdFromSignedInstance(signedInstance) {
    try {
        const encodedInstance = signedInstance?.startsWith('wixcode')
            ? signedInstance?.split('.')[2]
            : signedInstance?.split('.')[1];
        if (encodedInstance) {
            return JSON.parse(base64.decode(encodedInstance)).instanceId;
        }
    }
    catch (e) { }
}
//# sourceMappingURL=linguist.js.map